import { hasFreeMemoryCapacity } from "./memory";

const Memory = {
  hasFreeMemoryCapacity
};
export default Memory;
